import { Card, Divider, Flex, Typography } from 'antd'
import cn from 'clsx'
import React, { ReactNode } from 'react'

type CampaignSettingsPanelProps = {
    title: ReactNode
    description?: ReactNode
    children: ReactNode
    actions?: ReactNode
    headerActions?: ReactNode
    className?: string
}

export function CampaignSettingsPanel({
    title,
    description,
    children,
    actions,
    headerActions,
    className,
}: CampaignSettingsPanelProps) {
    return (
        <Card className={cn('w-full', className)}>
            <Flex
                justify="space-between"
                align="start"
                wrap="wrap"
                gap="middle"
                className="mb-6 flex-col sm:flex-row"
            >
                <Flex
                    vertical
                    gap={4}
                    className="min-w-0 flex-1"
                >
                    <Typography.Title
                        level={3}
                        className="!mb-0"
                    >
                        {title}
                    </Typography.Title>
                    {description && <Typography.Text type="secondary">{description}</Typography.Text>}
                </Flex>
                {headerActions}
            </Flex>

            {children}

            {actions && (
                <>
                    <Divider />
                    {actions}
                </>
            )}
        </Card>
    )
}
